import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { UnmappedStockistType } from "../../../domain/models/unmapped-stockist/unmapped-stockist-data";
import { RemoteFetchUnmappedStockist } from "../../../data/usecases/unmapped-stockist/remote-fetch-unmapped-stockist";
import { FetchUnmappedStockist } from "../../../domain/useages/unmapped-stockist/fetch-unmapped-stockist";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchUnmappedStockistInterface {
  unmappedStockist: UnmappedStockistType[];
  unmappedStockistState: FetchState;
  fetchUnmappedStockist: Function;
}

const initialStates = {
  unmappedStockist: [],
  unmappedStockistState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchUnmappedStockistSlice: StateCreator<
  FetchUnmappedStockistInterface
> = (set) => ({
  ...initialStates,
  fetchUnmappedStockist: async (filters: FetchUnmappedStockist.Params) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteUnmappedStockist = new RemoteFetchUnmappedStockist(
      `${BASE_URL}${Endpoints.FETCH_UNMAPPED_STOCKIST}`,
      axiosHttpClient
    );

    set(() => ({ unmappedStockistState: FetchState.LOADING }));
    let result = await remoteUnmappedStockist.fetch(filters);
    if (result && result.length > 0) {
      set(() => ({
        unmappedStockist: result,
        unmappedStockistState: FetchState.SUCCESS,
      }));
    } else {
      set(() => ({ unmappedStockistState: FetchState.ERROR }));
    }
  },
});
